import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=09a4bb69&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=09a4bb69&prod&scoped=true&lang=css&external"
import style1 from "./Orders.vue?vue&type=style&index=1&id=09a4bb69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a4bb69",
  null
  
)

export default component.exports